<!-- begin:: Brand -->
<div
  class="brand justify-content-start bg-white"
  [ngClass]="brandClasses"
  id="kt-aside"
  [ngStyle]="{ 'padding-left': filterView ? '0' : '' }"
>
  <ng-container *ngIf="asideSelfMinimizeToggle && !filterView">
    <!--begin::Toggle-->
    <button
      id="kt_aside_toggle"
      class="brand-toggle btn btn-sm px-0"
      (click)="themeService.toggleMinimized($event)"
    >
      <img alt="logo" [src]="themeService.logo" />
    </button>
    <!--end::Toolbar-->
  </ng-container>
</div>
<!-- end:: Brand -->
